<template>
  <div class="left-sidebar">
    <!-- Sidebar scroll-->
    <div class="scroll-sidebar">
      <!-- Sidebar navigation-->
      <nav class="sidebar-nav">
        <ul id="sidebarnav">
          <li class="nav-devider"></li>
          <li class="nav-label">Home</li>
          <li>
            <router-link to="/dashboard" aria-expanded="false">
              <i class="fa fa-tachometer"></i>
              <span class="hide-menu">Dashboard</span>
            </router-link>
          </li>
          <li class="nav-item">
            <div v-if="roleuserModules.includes(3) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#authentifications"
              >
                <i class="fa fa-key"></i>
                <span class="hide-menu">
                  &nbsp;&nbsp; Authentications
                  <span class="label label-rouded label-primary pull-right"
                    >4</span
                  >
                </span>
              </a>
              <div
                class="collapse"
                id="authentifications"
                aria-expanded="false"
              >
                <ul>
                  <div>
                    <a
                      data-toggle="collapse"
                      data-target="#roles"
                      class="has-arrow fa fa-gear"
                      >roles</a
                    >
                    <div id="roles" aria-expanded="false" class="collapse">
                      <ul>
                        <li>
                          <router-link to="/role">
                            <i class="fa fa-hand-o-right"></i> new role
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/managerole">
                            <i class="fa fa-hand-o-right"></i> manage roles
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <a
                      data-toggle="collapse"
                      data-target="#modules"
                      class="has-arrow fa fa-folder"
                      >modules</a
                    >
                    <div id="modules" aria-expanded="false" class="collapse">
                      <ul>
                        <li>
                          <router-link to="/newmodule">
                            <i class="fa fa-hand-o-right"></i> new module
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/managemodules">
                            <i class="fa fa-hand-o-right"></i> manage modules
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <a
                      data-toggle="collapse"
                      data-target="#permissions"
                      class="has-arrow fa fa-key"
                      >permissions</a
                    >
                    <div
                      id="permissions"
                      aria-expanded="false"
                      class="collapse"
                    >
                      <ul>
                        <li>
                          <router-link to="/permission">
                            <i class="fa fa-hand-o-right"></i> new permission
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/managepermissions">
                            <i class="fa fa-hand-o-right"></i> manage
                            permissions
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <a
                      data-toggle="collapse"
                      data-target="#users"
                      class="has-arrow fa fa-users"
                      >system users</a
                    >
                    <div id="users" aria-expanded="false" class="collapse">
                      <ul>
                        <li>
                          <router-link to="/newuser">
                            <i class="fa fa-hand-o-right"></i> new user
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/manageusers">
                            <i class="fa fa-hand-o-right"></i> manage users
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(4) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#products"
              >
                <i class="fa fa-truck"></i>
                <span class="hide-menu">
                  &nbsp;&nbsp; Products
                  <span class="label label-rouded label-primary pull-right"
                    >2</span
                  >
                </span>
              </a>
              <div class="collapse" id="products" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/newproduct">
                      <i class="fa fa-hand-o-right"></i> new product
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/manageproducts">
                      <i class="fa fa-hand-o-right"></i> manage products
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(13) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#suppliers"
              >
                <i class="fa fa-truck"></i>
                <span class="hide-menu">
                  &nbsp;&nbsp; Suppliers
                  <span class="label label-rouded label-primary pull-right"
                    >2</span
                  >
                </span>
              </a>
              <div class="collapse" id="suppliers" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/supplier">
                      <i class="fa fa-hand-o-right"></i> new supplier
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/managesuppliers">
                      <i class="fa fa-hand-o-right"></i> manage suppliers
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(14) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#consignees"
              >
                <i class="fa fa-truck"></i>
                <span class="hide-menu">
                  &nbsp;&nbsp; Consignees
                  <span class="label label-rouded label-primary pull-right"
                    >2</span
                  >
                </span>
              </a>
              <div class="collapse" id="consignees" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/manageconsignees">
                      <i class="fa fa-hand-o-right"></i> manage consignees
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(5) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#stocks"
              >
                <i class="fa fa-truck"></i>
                <span class="hide-menu">
                  &nbsp;&nbsp; Stocks
                  <span class="label label-rouded label-primary pull-right"
                    >2</span
                  >
                </span>
              </a>
              <div class="collapse" id="stocks" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/stock">
                      <i class="fa fa-hand-o-right"></i> new stock
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/managestocks">
                      <i class="fa fa-hand-o-right"></i> manage stocks
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(6) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#Transporters"
              >
                <i class="fa fa-truck"></i>
                <span class="hide-menu">Transporters</span>
                <span class="label label-rouded label-primary pull-right"
                  >3</span
                >
              </a>
              <div class="collapse" id="Transporters" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/newtransporter">
                      <i class="fa fa-hand-o-right"></i> new transporter
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/managetransporters">
                      <i class="fa fa-hand-o-right"></i> manage transporters
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/managetrucks">
                      <i class="fa fa-hand-o-right"></i> manage trucks
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(8) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#GoodsReceiving"
              >
                <i class="fa fa-money"></i>
                <span class="hide-menu">Goods receiving</span>
                <span class="label label-rouded label-primary pull-right"
                  >2</span
                >
              </a>
              <div class="collapse" id="GoodsReceiving" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/suppliergoods">
                      <i class="fa fa-hand-o-right"></i> Receive goods
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/managegoodsreceiving">
                      <i class="fa fa-hand-o-right"></i> manage goods received
                    </router-link>
                  </li>

                  <li>
                    <router-link to="/newoil">
                      <i class="fa fa-hand-o-right"></i> new engine oil
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/manageoilreceiving">
                      <i class="fa fa-hand-o-right"></i> manage engine oil
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(10) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#SaleSettings"
              >
                <i class="fa fa-money"></i>
                <span class="hide-menu">Sale order</span>
                <span class="label label-rouded label-primary pull-right"
                  >2</span
                >
              </a>
              <div class="collapse" id="SaleSettings" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/newsale">
                      <i class="fa fa-hand-o-right"></i> sale order
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/managesales">
                      <i class="fa fa-hand-o-right"></i> manage saleorders
                    </router-link>
                  </li>

                  <!-- <li>
                    <router-link to="/newinvoice">
                      <i class="fa fa-hand-o-right"></i> invoicing
                    </router-link>
                  </li> -->
                </ul>
              </div>
            </div>

            <div v-if="roleuserModules.includes(7) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#Accounts"
              >
                <i class="fa fa-money"></i>
                <span class="hide-menu">Accounts</span>
                <span class="label label-rouded label-primary pull-right"
                  >2</span
                >
              </a>
              <div class="collapse" id="Accounts" aria-expanded="false">
                <ul>
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#expenses"
                      class="has-arrow fa fa-money"
                    >
                      Expenses</a
                    >
                    <div class="collapse" id="expenses" aria-expanded="false">
                      <ul>
                        <li>
                          <router-link to="/manageexpenses">
                            <i class="fa fa-hand-o-right"></i> manage expenses
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </li>

                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#trips"
                      class="has-arrow fa fa-truck"
                    >
                      Trips</a
                    >
                    <div class="collapse" id="trips" aria-expanded="false">
                      <ul>
                        <li>
                          <router-link to="/trip">
                            <i class="fa fa-hand-o-right"></i> new trip
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/managetrips">
                            <i class="fa fa-hand-o-right"></i> manage trips
                          </router-link>
                        </li>

                        <li>
                          <router-link to="/manageinterchanges">
                            <i class="fa fa-hand-o-right"></i> manage
                            interchanges
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(12) === true">
              <router-link
                class="nav-link collapsed has-arrow anchorColors"
                to=""
                data-toggle="collapse"
                data-target="#EmployeeSettings"
              >
                <i class="fa fa-gears"></i>
                <span class="hide-menu">Employee Settings</span>
                <span class="label label-rouded label-success pull-right"
                  >1</span
                >
              </router-link>
              <div class="collapse" id="EmployeeSettings" aria-expanded="false">
                <ul>
                  <li>
                    <router-link
                      to=""
                      data-toggle="collapse"
                      data-target="#employees"
                      class="has-arrow fa fa-users"
                      >employees</router-link
                    >
                    <ul id="employees" aria-expanded="false" class="collapse">
                      <li>
                        <router-link to="/employee">
                          <i class="fa fa-hand-o-right"></i> new employee
                        </router-link>
                      </li>
                      <li>
                        <router-link to="/manageemployees">
                          <i class="fa fa-hand-o-right"></i> manage employees
                        </router-link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(11) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#Reports"
              >
                <i class="fa fa-money"></i>
                <span class="hide-menu">Reports</span>
                <span class="label label-rouded label-primary pull-right"
                  >2</span
                >
              </a>
              <div class="collapse" id="Reports" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/trucksales">
                      <i class="fa fa-hand-o-right"></i> truck sales
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/truckexpenses">
                      <i class="fa fa-hand-o-right"></i> truck expenses
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/productsales">
                      <i class="fa fa-hand-o-right"></i> product sales
                    </router-link>
                  </li>
                  <!-- <li>
                    <router-link to="/productpurchases">
                      <i class="fa fa-hand-o-right"></i> product purchases
                    </router-link>
                  </li> -->

                  <li>
                    <router-link to="/labourcharges">
                      <i class="fa fa-hand-o-right"></i> labour charges
                    </router-link>
                  </li>

                  <li>
                    <router-link to="/summary">
                      <i class="fa fa-hand-o-right"></i> Trips summary
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/consigneetrips">
                      <i class="fa fa-hand-o-right"></i> Consignee trips
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </nav>
      <!-- End Sidebar navigation -->
    </div>
    <!-- End Sidebar scroll-->
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["roleuserModules"]),
};
</script>


// WEBPACK FOOTER //
// src/layouts/sidebar.vue